export const INVALID_VALUE = "-";
